import {Button, Layout, Spacer, Text, Toggle} from '@di-nxt/components';
import React, {useCallback, useState} from 'react';
import {t} from '../../localization';
import {DataRowData} from './DataRowData';
import {getFormattedData} from './getFormattedData';
import {DataRowProps} from './types';

export const DataRow: React.FC<DataRowProps> = ({
  label,
  data,
  kind = 'Readonly',
  disabled,
  children,
  onEditModeChanged,
  onToggle,
  onPress,
}) => {
  // State
  const [editMode, setEditMode] = useState<boolean>(false);

  // Toggle edit mode
  const toggleEditMode = useCallback(() => {
    setEditMode(p => !p);
    onEditModeChanged && onEditModeChanged(true);
  }, [onEditModeChanged]);
  const dismissEditMode = useCallback(() => {
    setEditMode(false);
    onEditModeChanged && onEditModeChanged(false);
  }, [onEditModeChanged]);

  // Toggle - TODO: Use switch when available
  const handleToggle = useCallback(() => onToggle && onToggle(!data), [
    data,
    onToggle,
  ]);

  // Copy to clipboard - TODO: Web only
  const handleCopy = useCallback(() => {
    var textField = document.createElement('textarea');
    textField.innerText = getFormattedData(data);
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
  }, [data]);

  return (
    <Layout horizontal flex>
      <Layout vertical flex>
        <Text variant="inline_14_emphasis">{label}</Text>
        <Spacer height="6" />
        {(kind === 'Readonly' || kind === 'Copy' || kind === 'Toggle') && (
          <DataRowData data={data} onPress={onPress} />
        )}
        {kind === 'Edit' && !editMode && (
          <DataRowData data={data} onPress={onPress} />
        )}
        {kind === 'Edit' && editMode && (
          <Layout>{children && children(dismissEditMode)}</Layout>
        )}
      </Layout>
      {/** Right enhancer */}
      <Spacer height="6" />
      {kind === 'Copy' && (
        <Layout align="center">
          <Button
            kind="Secondary"
            size="Small"
            leftIcon="copy"
            title={t('components.datarow.buttons.copy')}
            onPress={handleCopy}
          />
        </Layout>
      )}
      {kind === 'Edit' && !editMode && (
        <Layout align="center">
          <Button
            kind="Secondary"
            size="Small"
            state={disabled ? 'Disabled' : 'Default'}
            title={t('components.datarow.buttons.edit')}
            onPress={!disabled ? toggleEditMode : undefined}
          />
        </Layout>
      )}
      {kind === 'Toggle' && (
        <Layout align="center">
          <Toggle
            kind={disabled ? 'Disabled' : 'Active'}
            on={data as boolean}
            onPress={disabled ? () => {} : handleToggle}
          />
        </Layout>
      )}
    </Layout>
  );
};
